import "@mui/material/Card";
import { type Theme } from "@mui/material/styles";

declare module "@mui/material/Card" {
  interface CardPropsVariantOverrides {
    blue: true;
    light: true;
  }
}

export function card(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: "relative",
          paddingX: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.customShadows.card,
          borderRadius: 16,
          zIndex: 0, // Fix Safari overflow: hidden with border radius
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: "17px 20px",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2),
          "&:last-child": {
            paddingBottom: 0,
          },
        },
      },
    },
  };
}
